export const tr = {
    'ad-decline-req': 'Reklam verme kurallarına aykırı olduğu için gruplar reddedildi.',
    'how-to-fix': 'Grubu nasıl düzenleyebileceğinizi "Durum" sütununda öğrenebilirsiniz.',
    'many-group-title': 'Moderasyonu geçmek için {count} grubu düzenleyin',
    'one-group-title': 'Moderasyonu geçmek için {count} grubu düzenleyin',
    'one-group-title-hint': 'Grup, moderasyonu geçemediği için öneri gösterilmektedir',
    'open-ad-list': 'Red nedenlerini öğrenmek ve düzenleme yapmak için reklamları ve grup ayarlarını kontrol edin.',
    'popup-ad-decline-req': 'Reklam verme kurallarına aykırı olduğu için grup reddedildi',
    'several-group-title-hint': 'Öneri, bazı gruplar moderasyonu geçemediği için gösterilmektedir',
    'show-many-group-button': '{count} grup göster',
    'show-one-group-button': '{count} grup göster',
    'show-some-group-button': '{count} grup göster',
    'simple-title': 'Moderasyonu geçmek için grubu düzenleyin',
    'some-group-title': 'Moderasyonu geçmek için {count} grubu düzenleyin',
    'twenty-one-group-title': 'Moderasyonu geçmek için {count} grubu düzenleyin'
};
